/** PURE_IMPORTS_START ._FromObservable PURE_IMPORTS_END */
import { FromObservable } from './FromObservable';
export var from = FromObservable.create;
//# sourceMappingURL=from.js.map 



//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/node_modules/rxjs/_esm5/observable/from.js
// module id = ../../../../rxjs/_esm5/observable/from.js
// module chunks = vendor